import { render, staticRenderFns } from "./zonghe_tongji.vue?vue&type=template&id=255802a6&scoped=true"
import script from "./zonghe_tongji.vue?vue&type=script&lang=js"
export * from "./zonghe_tongji.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255802a6",
  null
  
)

export default component.exports